<div
  class="absolute z-10 mt-1 max-h-72 w-full overflow-y-auto rounded-md border border-slate-200 bg-white shadow-lg sm:w-96"
>
  <ul #dropdownList>
    @if (isLoading()) {
      <li class="p-4 text-center text-sm text-slate-500">Carregando...</li>
    } @else {
      @for (variable of suggestions(); track variable.path; let i = $index; let first = $first) {
        @if (first || variable.category !== suggestions()[i - 1].category) {
          <li
            class="sticky top-0 z-10 border-b border-slate-200 bg-slate-100 px-3 py-1.5 text-xs font-semibold text-slate-600"
          >
            {{ variable.category }}
          </li>
        }
        <li
          (mousedown)="onItemMouseDown($event, variable)"
          [class.bg-indigo-50]="activeIndex() === i"
          [attr.data-index]="i"
          class="flex cursor-pointer items-start border-b border-slate-100 p-3 transition-colors duration-100 last:border-b-0 hover:bg-indigo-50"
        >
          <span
            [innerHTML]="getIcon(variable.type).icon | safeHtml"
            [class]="getIcon(variable.type).color + ' mt-0.5'"
          ></span>
          <div class="flex flex-col">
            <span class="text-sm font-semibold text-slate-800">{{ variable.label }}</span>
            <span class="mt-0.5 text-xs text-slate-500">{{ variable.description }}</span>
            <span class="mt-1 font-mono text-xs text-slate-500">{{ variable.path }}</span>
          </div>
        </li>
      } @empty {
        <li class="p-4 text-center text-sm text-slate-500">Nenhuma variável encontrada.</li>
      }
    }
  </ul>
</div>
